{
  "connected": "Обновления в реальном времени включены",
  "disconnected": "Обновления приостановлены, переподключаемся…"
}
